import { endpoints } from 'api/endpoints'
import { GetArrayResponse } from 'interfaces/api.interfaces'
import { CfrDefaultParam, CfrDefaultParamBase } from 'interfaces/api/cfrDefaultParams.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<CfrDefaultParam> => {
  const { data: response } = await axios.request<CfrDefaultParam[]>({
    method: 'GET',
    url: endpoints.cfrDefaultParams.getAll(),
  })
  return response
}

const update = async (pfrParams: CfrDefaultParamBase[]): Promise<void> => {
  await axios.request({
    method: 'PATCH',
    url: endpoints.cfrDefaultParams.update(),
    data: { pfrParams },
  })
}

export const cfrDefaultParamsApi = {
  getAll,
  update,
}
